<template>
  <label class="flex items-center gap-2.5 text-xs text-gray-700 sm:text-sm">
    <div class="grid size-5 grid-cols-1">
      <input
        type="checkbox"
        :name="name"
        :value="value"
        :checked="modelValue.includes(value)"
        class="peer col-start-1 row-start-1 size-5 appearance-none rounded border-2 border-gray-300 bg-white checked:border-blue-500 checked:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 forced-colors:appearance-auto"
        @change="onChange"
      />

      <svg
        class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white opacity-0 peer-checked:opacity-100"
        viewBox="0 0 14 14"
        fill="none"
        aria-hidden="true"
      >
        <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    {{ label }}
  </label>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['update:modelValue'],

  methods: {
    onChange(event) {
      const checked = event.target.checked
      const next = checked ? [...this.modelValue, this.value] : this.modelValue.filter((v) => v !== this.value)

      this.$emit('update:modelValue', next)
    },
  },
}
</script>
